import React, { useState, useEffect } from "react";
import allTeams from "../../data/teams"; // Adjust the import path as necessary
import { Link } from "react-router-dom";
import apiUrl from "../../config";

export default async function fetchSchedule(date) {
    try {
      const response = await fetch(`${apiUrl}/api/schedule/${date}`); // Adjust the endpoint as necessary
  
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      const data = await response.json();
      const schedule = (data.gameWeek || []).filter((game) => game.date === date);
      const scheduleData = schedule.length > 0 ? schedule[0].games : null;      
      // Find the gameWeek matching the given date
      return scheduleData;
    } catch (error) {
      console.error("Error fetching schedule:", error);
      return null; // Return null in case of an error
    }
  }